import yup from 'src/libraries/validator.library';
import {
    SensitiveCitiesListSchema,
    SensitiveCitiesFormSchema,
    ISensitiveCitiesForm,
  } from 'src/models/sensitive-cities.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async () => {
    return http.get('sensitiveCities', { limit: 0 }, SensitiveCitiesListSchema);
  },
  updatePUT: async (id: number, data: ISensitiveCitiesForm) => {
    return http.put(`sensitiveCities/${id}`, data, SensitiveCitiesFormSchema);
  },
  addPOST: async (data: ISensitiveCitiesForm) => {
    return http.post('sensitiveCities', data, SensitiveCitiesFormSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`sensitiveCities/${id}`, yup.mixed());
  },
};

export default services;
